import { render, staticRenderFns } from "./CouponManage.vue?vue&type=template&id=1fa1674e&"
import script from "./CouponManage.vue?vue&type=script&lang=js&"
export * from "./CouponManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports